import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FullBleedHero } from "../components/FullBleedHero";
import { MagnifyingGlass, UserPlus, Storefront, MagnifyingGlassPlus, FileText, CreditCard, ShieldCheck, Handshake, ArrowRight } from "@phosphor-icons/react";

const steps = [
  { icon: MagnifyingGlass, t: "Discover", d: "Explore EBG FinCorp and our brands." },
  { icon: UserPlus, t: "Create Account", d: "Sign up and verify your details." },
  { icon: Storefront, t: "Explore Brands", d: "Browse opportunities that interest you." },
  { icon: MagnifyingGlassPlus, t: "Deep Dive", d: "Study brand details, financial information and partnership terms." },
  { icon: FileText, t: "Express Interest", d: "Fill the intent form for your chosen brands." },
  { icon: CreditCard, t: "Pay Intent Fee", d: "Pay the intent fee to continue with your application." },
  { icon: ShieldCheck, t: "Due Diligence", d: "We verify your profile and documents." },
  { icon: Handshake, t: "Partnership", d: "Agreement signed. You're now a partner." },
];

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page">
      <FullBleedHero
        image="/how-it-works-hero.png"
        alt="A golden staircase ascending out of darkness toward the light"
        eyebrow="How It Works"
        title={<>Your journey from<br />interest to <span className="gold-text italic">franchise partner.</span></>}
        subtitle="Like an ascent toward the light, every partnership is built one deliberate step at a time — eight of them, from your first visit to a signed franchise agreement."
      />
      <section className="px-6 md:px-12 lg:px-20 py-16 md:py-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s, i) => (
            <motion.div key={s.t} initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 4) * 0.08 }}
              className="relative bg-navy-900 border border-white/10 rounded-xl p-6 hover:border-gold/40 transition-colors">
              <span className="absolute top-5 right-5 font-display text-4xl text-white/10">{String(i + 1).padStart(2, "0")}</span>
              <div className="grid place-items-center w-12 h-12 rounded-lg bg-gold/10 border border-gold/20"><s.icon size={24} className="text-gold" weight="light" /></div>
              <h3 className="font-display text-2xl text-white mt-5">{s.t}</h3>
              <p className="text-sm text-ebg-muted mt-2 leading-relaxed">{s.d}</p>
            </motion.div>
          ))}
        </div>
        <div className="text-center mt-14">
          <Link to="/explore" className="inline-flex items-center gap-2 btn-gold px-8 py-3.5 rounded-md">Start Exploring <ArrowRight size={18} /></Link>
        </div>
      </section>
    </div>
  );
}
